import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import Typo from 'components/Typo';
import { profile } from 'lang/en.json';

// Replaces the Add Media Coverage control for members: only the editorial team
// adds coverage. Admins keep the real control, and a plain visitor has nothing
// to report.
const MissedCoverage = ({ className }) => {
    const { isAuthorized, isAdmin } = useSelector(authSelector);

    if (!isAuthorized || isAdmin) return null;

    return (
        <Typo variant={'small'} className={className}>
            {profile.media_coverage.missed}
        </Typo>
    );
};

export default MissedCoverage;
